import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectLocale } from '@/store/slices/settings.selectors';
import { setLocale } from '@/store/slices/settings.slice';
import type { AppLocale } from '@/types/common.types';

export function useLocale() {
  const dispatch = useAppDispatch();
  const locale = useAppSelector(selectLocale);

  const changeLocale = useCallback((next: AppLocale) => dispatch(setLocale(next)), [dispatch]);

  return { locale, changeLocale };
}
